import { Component, OnDestroy, OnInit } from '@angular/core';
import { RouterOutlet } from '@angular/router';

import { OidcSecurityService } from 'angular-auth-oidc-client';

import { environment } from 'environments/environment';

import { InactivityMonitorService } from './shared/services/inactivity-monitor.service';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrl: './app.component.scss',
  standalone: true,
  imports: [RouterOutlet],
  providers: [InactivityMonitorService],
})
export class AppComponent implements OnInit, OnDestroy {
  constructor(
    private oidcSecurityService: OidcSecurityService,
    private inactivityMonitorService: InactivityMonitorService,
  ) {}

  ngOnInit(): void {
    this.oidcSecurityService?.checkAuth().subscribe();

    if (environment.production) {
      this.inactivityMonitorService.start();
    }
  }

  ngOnDestroy(): void {
    this.inactivityMonitorService.stop();
  }
}
